<template>
  <v-app-bar dark extended max-height="112" flat width="100%" class="primary">
    <v-container>
      <v-row justify="center">
        <v-col xs="12" md="12" lg="8" xl="6">

          <v-row no-gutters>
            <v-col xs="12" md="6" lg="8">
              <v-toolbar-title class="text-left vertical" v-html="appName"></v-toolbar-title>
            </v-col>
            <v-col xs="12" md="6" lg="4">
              <v-row no-gutters justify="end">
                <v-btn depressed class="success" router :to="backRoute" v-if="isSuperuser && showCdLinks">
                  <v-icon left>chevron_left</v-icon>Back
                </v-btn>
                <v-btn text @click="logout" class="pa-0"><v-icon right>exit_to_app</v-icon></v-btn>
              </v-row>
            </v-col>
          </v-row>

        </v-col>
      </v-row>
    </v-container>
    <template v-slot:extension>
      <v-container>
        <v-row justify="center" no-gutters>
          <v-col xs="12" md="12" lg="8" xl="6">
            <div v-show="!showCdLinks">
              <SuperUserMenuLinks />
            </div>
            <div v-show="showCdLinks">
              <CustomerDetailsMenuLinks />
            </div>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </v-app-bar>
</template>

<script>
import SuperUserMenuLinks from './SuperUserMenuLinks.vue';
import CustomerDetailsMenuLinks from './CustomerDetails/MenuLinks.vue';

export default {
  name: 'Header',
  components: { CustomerDetailsMenuLinks, SuperUserMenuLinks },
  data() {
    return {
      defaultAppName: process.env.VUE_APP_NAME,
    };
  },
  computed: {
    appName() {
      return this.$store.state.customPageTitle || this.defaultAppName;
    },
    showCdLinks() {
      return this.$store.state.showCdLinks;
    },
    isSuperuser() {
      return this.$store.getters['auth/isSuperuser'];
    },
    backRoute() {
      return this.$store.state.backRoute;
    },
  },
  methods: {
    logout() {
      const axios = this.$http;
      this.$store.dispatch('auth/logout', { axios }).then(() => {
        this.$router.push('/login');
      });
    },
  },
};
</script>

<style lang="scss">
  @import '../assets/scss/index';

  .v-app-bar {
    .v-toolbar__title {
      height: 100%;
      display: flex;
      align-items: center;
    }
    .v-toolbar__extension {
      background-color: $brand-lighter-blue;
      & .v-btn-toggle {
        .v-btn {
          &:before {
            background-color: transparent;
          }
        }
        & .v-btn--active {
          position: relative;
          &:before {
            position: absolute;
            opacity: 1;
            width: 50%;
            bottom: 0;
            top: initial;
            left: 0;
            margin-left: 25%;
            height: 3px;
            background-color: #ADCE6D;
          }
        }
      }
    }
  }
</style>
